import { useEffect } from 'react';
import { useStore } from './store';
import { Chrome } from './components/Chrome';
import { Welcome } from './surfaces/Welcome';
import { Assessment } from './surfaces/Assessment';
import { Report } from './surfaces/Report';
import { Practice } from './surfaces/Practice';
import { Templates } from './surfaces/Templates';
import { Organisations } from './surfaces/Organisations';
import { OrgDetail } from './surfaces/OrgDetail';
import { History } from './surfaces/History';
import { Settings } from './surfaces/Settings';
import { Setup } from './surfaces/Setup';
import { CampaignEditor } from './surfaces/CampaignEditor';

export default function App() {
  const screen = useStore((s) => s.screen);
  const checkResumable = useStore((s) => s.checkResumable);
  const loadPublicSettings = useStore((s) => s.loadPublicSettings);
  // Once on boot: offer to continue any assessment left in progress server-side, and apply
  // any deployment branding (product name, palette).
  useEffect(() => checkResumable(), [checkResumable]);
  useEffect(() => loadPublicSettings(), [loadPublicSettings]);
  return (
    <>
      <Chrome />
      {screen === 'welcome' && <Welcome />}
      {screen === 'assessment' && <Assessment />}
      {screen === 'report' && <Report />}
      {screen === 'practice' && <Practice />}
      {screen === 'templates' && <Templates />}
      {screen === 'history' && <History />}
      {screen === 'organisations' && <Organisations />}
      {screen === 'orgDetail' && <OrgDetail />}
      {screen === 'settings' && <Settings />}
      {screen === 'setup' && <Setup />}
      <CampaignEditor />
    </>
  );
}
